const name = 'donut';


const contents = `
  <circle fill="black" cx="31" cy="41" r="29"/>
  <circle fill="white" cx="31" cy="41" r="20.5"/>
  <circle fill="black" cx="31" cy="41" r="10"/>
`;


/** @type {import ('./types').Icon} */
const icon = {
  name,
  contents,
};

export default icon;

